module.exports = __webpack_public_path__ + "img/70800.5c58a1cc.jpg";